import React, { useState } from 'react';
import { Script } from 'gatsby';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

export default function MavenoidChatButton({ children, ...otherProps }) {
  const [clicked, setClicked] = useState(false);

  function openChatWidget() {
    setClicked(true);
    window?.mavenoidPushHandler?.(); // ! for after initial load
    window?.dataLayer?.push({ event: 'support_chat_open' });
  }

  return (
    <>
      {clicked && (
        <Script
          key="mavenoid"
          src="https://widget-hosts.mavenoid.com/custom-embedding-scripts/radio-systems-corp.js"
          onLoad={() => {
            window.mavenoid = window?.mavenoid || [];

            const observer = new MutationObserver(
              (_mutations, mutationInstance) => {
                const mavenoidComponent =
                  document.querySelector('mavenoid-assistant');
                if (mavenoidComponent) {
                  window?.mavenoidPushHandler(); // ! initial load to open chat independent of loading speed
                  mutationInstance.disconnect();
                }
              }
            );

            observer.observe(document, {
              childList: true,
              subtree: true,
            });
          }}
        />
      )}
      <Box
        as="button"
        type="button"
        className="supportChatButton"
        w="full"
        outlineColor="inherit"
        {...otherProps}
        onClick={() => openChatWidget()}
        onKeyDown={e => {
          if (e.code === 'Enter' || e.code === 'Space') {
            openChatWidget();
          }
        }}
      >
        <Text color="typography.base" textStyle="body" textAlign="left">
          {children}
        </Text>
      </Box>
    </>
  );
}

MavenoidChatButton.propTypes = {
  children: PropTypes.node.isRequired,
};
